// 财务菜单
export default [
  {
    path: '/ToTransfer',
    name: '待转款列表',
    component: resolve => require(['../views/ToTransfer/index'], resolve)
  },
  {
    path: '/HistoryTransfer',
    name: '历史转款列表',
    component: resolve => require(['../views/HistoryTransfer/index'], resolve)
  },
]




// WEBPACK FOOTER //
// ./src/router/financial.js